import React, { Component } from 'react'
import { Mutation } from 'react-apollo'

import { RESET_PASSWORD } from '../../mutations'

import Footer from '../../components/Footer/'
import PasswordForm from '../../containers/PasswordForm/'

import logo from '../../assets/logo.svg'
import desert from '../../assets/hero/login/desert.jpg'
import desertMobile from '../../assets/hero/login/desert-mobile.jpg'
import rock from '../../assets/hero/login/rock.jpg'
import rockMobile from '../../assets/hero/login/rock-mobile.jpg'
import sea from '../../assets/hero/login/sea.jpg'
import seaMobile from '../../assets/hero/login/sea-mobile.jpg'
import snow from '../../assets/hero/login/snow.jpg'
import snowMobile from '../../assets/hero/login/snow-mobile.jpg'
import { Container, Logo } from './styles'

class Reset extends Component {

  generateRandomImage() {
    let images = [
      {
        desktop: desert,
        mobile: desertMobile
      },
      {
        desktop: rock,
        mobile: rockMobile
      },
      {
        desktop: sea,
        mobile: seaMobile
      },
      {
        desktop: snow,
        mobile: snowMobile
      }
    ]

    // randomnize
    return images[Math.floor(Math.random() * images.length)]
  }


  render() {
    const hero = this.generateRandomImage()

    return (
      <Container image={hero.desktop} mobile={hero.mobile}>
        <Logo src={logo} alt="logo" />

        <Mutation mutation={RESET_PASSWORD}>
          {(resetPassword, { data, loading, error }) => {
            return <PasswordForm match={this.props.match} history={this.props.history} data={data} error={error} loading={loading} resetPassword={resetPassword} />
          }}
        </Mutation>

        <Footer type="transparent" />
      </Container>
    )
  }
}

export default Reset



// WEBPACK FOOTER //
// ./src/views/Reset/index.js